import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import Dashboard from "../Components/layout/Dashboard";
import { lightTheme } from "../Theme/Light_Theme";

const AdminIndex = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checkingAuth, setCheckingAuth] = useState(true); 

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate(`/AdminLogin?redirect=${encodeURIComponent(location.pathname)}`, {
        replace: true,
      });
    } else {
      setCheckingAuth(false);
    }
  }, []);

  if (checkingAuth) {
    return null;
  }

  return (
    <Box>
      <ThemeProvider theme={lightTheme}>
        <CssBaseline />
        <Dashboard />
      </ThemeProvider>
    </Box>
  );
};

export default AdminIndex;
